// Chemin: C:\gestion-copro\src\pages\admin-saas\CrmProspectDetailPage.tsx
// Session 192 : Page dédiée prospect CRM — timeline complète de la relation
// Session 206 : Import réponse entrante PDF + analyse SENTINELLE + timeline enrichie
// Session 193 : Ajout sélecteur segment dans ModalEdition
// Session 199 : Refonte complète — layout 3 colonnes plein écran
// Session 207 : buildContexte injecte les notes de suivi (5 dernières, triées) dans le prompt SENTINELLE
//               Colonne gauche : dossier prospect (infos, pipeline, contact, SENTINELLE data)
//               Colonne centrale : timeline + documents déposés
//               Colonne droite : SENTINELLE CRM intégré (chat persisté + dropzone PDF)
// Session 208 : SENTINELLE retourne JSON structuré pour les mails → boutons Gmail + Copier inline sous la bulle

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  ArrowLeft,
  ArrowDownLeft,
  Edit3,
  Trash2,
  User,
  Mail,
  Phone,
  Globe,
  MapPin,
  ExternalLink,
  Sparkles,
  StickyNote,
  AlertTriangle,
  CalendarClock,
  Crosshair,
  Ruler,
  Check,
  X,
  MessageSquarePlus,
  RefreshCw,
  Send,
  Copy,
  RotateCcw,
  Users,
  Building2,
  Megaphone,
  ArrowRightLeft,
  Clock,
  FileText,
  Upload,
  Trash,
  Download,
  ChevronRight,
  RotateCw,
  CheckCircle,
} from 'lucide-react';
import {
  Prospect,
  TypeProspect,
  TypeCibleProspect,
  SegmentProspect,
  LABELS_SEGMENT_PROSPECT,
  COULEURS_SEGMENT_PROSPECT,
  ResponsableProspect,
  NoteSuivi,
  HistoriqueMailProspect,
  InfoResponsable,
  StatutProspect,
  TypeTemplateMail,
  LABELS_STATUT_PROSPECT,
  COLONNES_KANBAN,
  LABELS_TYPE_CIBLE,
  LABELS_TYPE_PROSPECT,
  LABELS_TYPE_TEMPLATE,
  DocumentProspect,
  TypeDocumentProspect,
  LABELS_TYPE_DOCUMENT_PROSPECT,
  COULEURS_TYPE_DOCUMENT_PROSPECT,
  MessageConversationProspect,
  AnalyseReponseProspect,
  LABELS_QUALIFICATION_REPONSE,
  COULEURS_QUALIFICATION_REPONSE,
} from '../../types/crm.types';
import {
  chargerProspects,
  chargerProspectParId,
  chargerResponsables,
  getLabelResponsable,
  getCouleurResponsable,
  mettreAJourProspect,
  supprimerProspect,
  ajouterNote,
  supprimerNote,
  modifierNote,
  rapprocherProspectUser,
  changerStatutProspect,
  ajouterHistoriqueMail,
  ajouterDocumentProspect,
  chargerDocumentsProspect,
  supprimerDocumentProspect,
  chargerConversationProspect,
  ajouterMessageConversation,
  reinitialiserConversationProspect,
  importerReponseProspect,
  enregistrerAnalyseReponse,
  supprimerMailHistorique,
  marquerMailEnvoye,
} from '../../services/crm.service';
import {
  genererMailProspection,
  ResultatMailProspection,

} from '../../services/prospection.service';
import { useAuth } from '../../context/AuthContext';
import { Timestamp } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';

// ============================================
// HELPERS
// ============================================

// ============================================
// SUGGESTIONS SENTINELLE PAR STATUT PIPELINE
// ============================================

const SUGGESTIONS_PAR_STATUT: Record<string, [string, string, string]> = {
  identifie: [
    'Résume ce prospect en 3 points clés',
    'Quel angle pour un premier mail de contact ?',
    'Rédige un mail de premier contact SCUD',
  ],
  contacte: [
    "Analyse l'historique des échanges avec ce prospect",
    'Doit-on relancer ? Si oui, quel angle adopter ?',
    'Rédige une relance SCUD adaptée au silence',
  ],
  interesse: [
    "Quels sont les signaux d'intérêt identifiés ?",
    'Comment préparer la démo pour ce profil ?',
    'Rédige un mail de confirmation et de cadrage démo',
  ],
  demo: [
    'Quelles objections anticiper avec ce type de structure ?',
    "Comment présenter l'offre pour maximiser la conversion ?",
    'Rédige un mail de suivi post-démo percutant',
  ],
  converti: [
    'Comment transformer ce client en ambassadeur actif ?',
    'Quel upsell est pertinent pour ce profil ?',
    'Rédige un mail de bienvenue personnalisé',
  ],
  perdu: [
    "Analyse pourquoi ce prospect n'a pas converti",
    'Ce prospect est-il ré-activable ? Dans quelles conditions ?',
    'Rédige un mail de maintien de contact à froid',
  ],
};

// ============================================
// HELPER — DÉTECTION MAIL JSON SENTINELLE
// ============================================

interface MailSentinelle {
  objet: string;
  corps: string;
}

const parserMailSentinelle = (content: string): MailSentinelle | null => {
  try {
    const trimmed = content.trim();
    // Chercher un bloc JSON avec type:"mail" dans le contenu
    const match = trimmed.match(/\{[\s\S]*"type"\s*:\s*"mail"[\s\S]*\}/);
    if (!match) return null;
    const parsed = JSON.parse(match[0]);
    if (parsed.type === 'mail' && parsed.objet && parsed.corps) {
      return { objet: parsed.objet, corps: parsed.corps };
    }
    return null;
  } catch {
    return null;
  }
};

const ICONES_TYPE_PROSPECT: Record<TypeProspect, React.ReactNode> = {
  association: <Users size={16} className="text-purple-500" />,
  copropriete: <Building2 size={16} className="text-blue-500" />,
  individu: <User size={16} className="text-green-500" />,
  prescripteur: <Megaphone size={16} className="text-amber-500" />,
};

const formatDate = (ts?: Timestamp | null): string => {
  if (!ts) return '—';
  try {
    return ts.toDate().toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
  } catch { return '—'; }
};

const formatDateRelative = (d: Date): string => {
  try {
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch { return '—'; }
};

const formatTaille = (octets?: number): string => {
  if (!octets) return '';
  if (octets < 1024) return `${octets} o`;
  if (octets < 1024 * 1024) return `${Math.round(octets / 1024)} Ko`;
  return `${(octets / (1024 * 1024)).toFixed(1)} Mo`;
};

// ============================================
// MODAL ÉDITION PROSPECT
// ============================================

interface ModalEditionProps {
  prospect: Prospect;
  responsables: InfoResponsable[];
  onFermer: () => void;
  onSauvegarder: (data: Partial<Prospect>) => Promise<void>;
}

const ModalEdition: React.FC<ModalEditionProps> = ({ prospect, responsables, onFermer, onSauvegarder }) => {
  const [nom, setNom] = useState(prospect.nom);
  const [contactNom, setContactNom] = useState(prospect.contactNom || '');
  const [contactEmail, setContactEmail] = useState(prospect.contactEmail || '');
  const [contactTelephone, setContactTelephone] = useState(prospect.contactTelephone || '');
  const [adresse, setAdresse] = useState(prospect.adresse || '');
  const [siteWeb, setSiteWeb] = useState(prospect.siteWeb || '');
  const [source, setSource] = useState(prospect.source || '');
  const [objectifContact, setObjectifContact] = useState(prospect.objectifContact || '');
  const [tailleStructure, setTailleStructure] = useState(prospect.tailleStructure || '');
  const [prochaineAction, setProchaineAction] = useState(prospect.prochaineAction || '');
  const [dateProchaineAction, setDateProchaineAction] = useState(
    prospect.dateProchaineAction
      ? new Date(prospect.dateProchaineAction.toDate()).toISOString().split('T')[0]
      : ''
  );
  const [responsable, setResponsable] = useState<ResponsableProspect>(prospect.responsable);
  const [typeCible, setTypeCible] = useState<TypeCibleProspect>(prospect.typeCible);
  const [segment, setSegment] = useState<SegmentProspect>(prospect.segment || 'ambassadeur');
  const [problematiques, setProblematiques] = useState<string[]>(prospect.problematiques || []);
  const [problematiqueSaisie, setProblematiqueSaisie] = useState('');
  const [saving, setSaving] = useState(false);

  const PROBLEMATIQUES_PREDEFINIES = [
    'Syndic opaque / manque de transparence',
    'Charges excessives ou injustifiées',
    'Travaux mal gérés ou non votés',
    'Absence de communication du syndic',
    'AG mal organisées ou non conformes',
    'Litiges avec copropriétaires',
    'Problèmes de recouvrement',
    'Carnet d\'entretien non tenu',
  ];

  const toggleProblematique = (p: string) => {
    setProblematiques(prev =>
      prev.includes(p) ? prev.filter(x => x !== p) : [...prev, p]
    );
  };

  const ajouterProblematiqueSaisie = () => {
    const val = problematiqueSaisie.trim();
    if (val && !problematiques.includes(val)) {
      setProblematiques(prev => [...prev, val]);
    }
    setProblematiqueSaisie('');
  };

  const handleSubmit = async () => {
    if (!nom.trim()) return;
    setSaving(true);
    try {
      await onSauvegarder({
        nom, contactNom, contactEmail, contactTelephone, adresse, siteWeb,
        source, objectifContact, tailleStructure, prochaineAction, responsable, typeCible, segment,
        problematiques,
        dateProchaineAction: dateProchaineAction ? Timestamp.fromDate(new Date(dateProchaineAction)) : undefined,
      });
      onFermer();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-bold text-gray-800">Modifier le prospect</h2>
          <button onClick={onFermer} className="p-1 hover:bg-gray-100 rounded"><X size={20} /></button>
        </div>
        <div className="p-4 space-y-4">
          <div>
            <label className="block text-xs text-gray-500 mb-1">Nom *</label>
            <input type="text" value={nom} onChange={(e) => setNom(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-emerald-500" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs text-gray-500 mb-1">Produit visé</label>
              <select value={typeCible} onChange={(e) => setTypeCible(e.target.value as TypeCibleProspect)}
                className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-emerald-500">
                {Object.entries(LABELS_TYPE_CIBLE).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">Responsable</label>
              <select value={responsable} onChange={(e) => setResponsable(e.target.value as ResponsableProspect)}
                className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-emerald-500">
                {responsables.map((r) => <option key={r.identifiant} value={r.identifiant}>{r.nomComplet}</option>)}
              </select>
            </div>
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Segment</label>
            <div className="flex gap-2">
              {(['ambassadeur', 'client_direct', 'recommandeur'] as SegmentProspect[]).map((s) => (
                <button key={s} type="button" onClick={() => setSegment(s)}
                  className={`flex-1 px-3 py-2 rounded-lg text-xs font-semibold border transition-colors ${
                    segment === s
                      ? COULEURS_SEGMENT_PROSPECT[s]
                      : 'bg-white text-gray-400 border-gray-200 hover:border-gray-300'
                  }`}>
                  {LABELS_SEGMENT_PROSPECT[s]}
                </button>
              ))}
            </div>
          </div>
          <div className="border-t pt-3 space-y-2">
            <p className="text-xs font-semibold text-gray-400 uppercase">Contact</p>
            <input type="text" value={contactNom} onChange={(e) => setContactNom(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-emerald-500" placeholder="Nom du contact" />
            <input type="email" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-emerald-500" placeholder="Email" />
            <input type="tel" value={contactTelephone} onChange={(e) => setContactTelephone(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-emerald-500" placeholder="Téléphone" />
            <input type="text" value={adresse} onChange={(e) => setAdresse(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-emerald-500" placeholder="Adresse / Ville" />
            <input type="url" value={siteWeb} onChange={(e) => setSiteWeb(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-emerald-500" placeholder="Site web" />
          </div>
          <div className="border-t pt-3 space-y-3">
            <p className="text-xs font-semibold text-amber-600 uppercase">SENTINELLE</p>
            <div>
              <label className="block text-xs text-gray-500 mb-1.5">Problématiques identifiées</label>
              <div className="flex flex-wrap gap-1.5 mb-2">
                {PROBLEMATIQUES_PREDEFINIES.map((p) => (
                  <button key={p} type="button" onClick={() => toggleProblematique(p)}
                    className={`px-2.5 py-1 rounded-full text-xs font-medium border transition-colors ${
                      problematiques.includes(p)
                        ? 'bg-amber-100 text-amber-800 border-amber-300'
                        : 'bg-white text-gray-500 border-gray-200 hover:border-amber-300 hover:text-amber-700'
                    }`}>
                    {problematiques.includes(p) ? '✓ ' : '+ '}{p}
                  </button>
                ))}
              </div>
              {problematiques.filter(p => !PROBLEMATIQUES_PREDEFINIES.includes(p)).map((p) => (
                <div key={p} className="flex items-center gap-1 mb-1">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800 border border-amber-300">✓ {p}</span>
                  <button type="button" onClick={() => toggleProblematique(p)} className="text-gray-400 hover:text-red-500 text-xs">✕</button>
                </div>
              ))}
              <div className="flex gap-2 mt-1">
                <input type="text" value={problematiqueSaisie}
                  onChange={(e) => setProblematiqueSaisie(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); ajouterProblematiqueSaisie(); } }}
                  className="flex-1 px-3 py-1.5 border rounded-lg text-xs focus:ring-2 focus:ring-amber-500"
                  placeholder="Saisir une problématique personnalisée..." />
                <button type="button" onClick={ajouterProblematiqueSaisie}
                  className="px-3 py-1.5 bg-amber-100 text-amber-700 rounded-lg text-xs font-semibold hover:bg-amber-200">
                  +
                </button>
              </div>
            </div>
            <input type="text" value={objectifContact} onChange={(e) => setObjectifContact(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-amber-500" placeholder="Objectif de contact" />
            <input type="text" value={tailleStructure} onChange={(e) => setTailleStructure(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-amber-500" placeholder="Taille / Adhérents" />
            <input type="text" value={source} onChange={(e) => setSource(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-emerald-500" placeholder="Source" />
            <div className="flex gap-3">
              <input type="text" value={prochaineAction} onChange={(e) => setProchaineAction(e.target.value)}
                className="flex-1 px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-amber-500" placeholder="Prochaine action" />
              <input type="date" value={dateProchaineAction} onChange={(e) => setDateProchaineAction(e.target.value)}
                className="w-40 px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-amber-500" />
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-3 p-4 border-t bg-gray-50 rounded-b-xl">
          <button onClick={onFermer} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-200 rounded-lg">Annuler</button>
          <button onClick={handleSubmit} disabled={!nom.trim() || saving}
            className="px-6 py-2 bg-emerald-600 text-white text-sm font-semibold rounded-lg hover:bg-emerald-700 disabled:opacity-50">
            {saving ? 'Enregistrement...' : 'Modifier'}
          </button>
        </div>
      </div>
    </div>
  );
};

// ============================================
// MODAL MAIL SENTINELLE (inchangée)
// ============================================

interface ModalMailProps {
  prospect: Prospect;
  onFermer: () => void;
  onMailGenere: () => void;
  onMarquerEnvoye?: (mailId: string, contenuFinal: string) => Promise<void>;
}

const ModalMailSentinelle: React.FC<ModalMailProps> = ({ prospect, onFermer, onMailGenere, onMarquerEnvoye }) => {
  const [template, setTemplate] = useState<TypeTemplateMail>('premier_contact');
  const [instructionsLibres, setInstructionsLibres] = useState('');
  const [generation, setGeneration] = useState(false);
  const [resultat, setResultat] = useState<ResultatMailProspection | null>(null);
  const [erreur, setErreur] = useState('');
  const [copie, setCopie] = useState(false);
  const [ouvert, setOuvert] = useState(false);
  const [brouillonId, setBrouillonId] = useState<string | null>(null);
  const [contenuBrouillon, setContenuBrouillon] = useState('');
  const [contenuFinal, setContenuFinal] = useState('');
  const [marquerEnCours, setMarquerEnCours] = useState(false);

  useEffect(() => {
    if (prospect.historiqueMails?.length > 0) setTemplate('relance_demo');
    else if (prospect.segment === 'ambassadeur') setTemplate('proposition_partenariat');
    else setTemplate('premier_contact');
  }, [prospect]);

  const handleGenerer = async () => {
    setGeneration(true); setErreur(''); setResultat(null); setOuvert(false);
    try {
      const mail = await genererMailProspection(prospect.id, template, instructionsLibres || undefined);
      setResultat(mail);
    } catch (err: unknown) {
      setErreur(err instanceof Error ? err.message : 'Erreur lors de la génération.');
    } finally { setGeneration(false); }
  };

  const handleEnregistrer = async () => {
    if (!resultat) return;
    await ajouterHistoriqueMail(prospect.id, {
      objet: resultat.objet, template,
      destinataire: prospect.contactEmail || '',
      auteur: prospect.responsable, envoye: false, apercu: resultat.contenuTexte,
    });
    onMailGenere(); onFermer();
  };

  const handleOuvrirGmail = async () => {
    if (!resultat || !prospect.contactEmail) return;
    const to = encodeURIComponent(prospect.contactEmail);
    const subject = encodeURIComponent(resultat.objet);
    const body = encodeURIComponent(resultat.contenuTexte);
    window.open(`https://mail.google.com/mail/?view=cm&to=${to}&su=${subject}&body=${body}`, '_blank');
    setOuvert(true);
    setContenuBrouillon(resultat.contenuTexte);
    setContenuFinal(resultat.contenuTexte);
    try {
      const mailId = await ajouterHistoriqueMail(prospect.id, {
        objet: resultat.objet, template,
        destinataire: prospect.contactEmail,
        auteur: prospect.responsable, envoye: false, apercu: resultat.contenuTexte,
        contenuHtml: resultat.contenuHtml,
      });
      setBrouillonId(mailId);
    } catch (err) {
      console.error('[CRM] Erreur enregistrement brouillon:', err);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-[60] flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between p-4 border-b bg-gradient-to-r from-blue-600 to-blue-700 rounded-t-xl">
          <div className="flex items-center gap-2 text-white">
            <Sparkles size={20} />
            <h2 className="font-bold">SENTINELLE — Mail pour {prospect.nom}</h2>
          </div>
          <button onClick={onFermer} className="p-1 text-white/80 hover:text-white"><X size={20} /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          {!resultat && (
            <>
              <div className="grid grid-cols-2 gap-2">
                {([
                  { value: 'premier_contact' as TypeTemplateMail, label: 'Premier contact', desc: 'Première prise de contact' },
                  { value: 'relance_demo' as TypeTemplateMail, label: 'Relance / Démo', desc: 'Après un échange' },
                  { value: 'proposition_partenariat' as TypeTemplateMail, label: 'Partenariat', desc: 'Pour associations' },
                  { value: 'libre' as TypeTemplateMail, label: 'Rédaction libre', desc: 'Consignes personnalisées' },
                ]).map((t) => (
                  <button key={t.value} onClick={() => setTemplate(t.value)}
                    className={`text-left p-3 rounded-lg border-2 transition-colors ${template === t.value ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-300'}`}>
                    <p className="text-sm font-semibold text-gray-800">{t.label}</p>
                    <p className="text-xs text-gray-500">{t.desc}</p>
                  </button>
                ))}
              </div>
              {template === 'libre' && (
                <textarea value={instructionsLibres} onChange={(e) => setInstructionsLibres(e.target.value)} rows={3}
                  className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500 resize-none"
                  placeholder="Consignes pour SENTINELLE..." />
              )}
              <div className="bg-gray-50 rounded-lg p-3 text-xs text-gray-600 space-y-0.5">
                <p className="font-semibold text-gray-400 uppercase mb-1">Contexte SENTINELLE</p>
                <p><span className="font-semibold">Destinataire :</span> {prospect.contactNom || prospect.nom} ({prospect.contactEmail})</p>
                {prospect.problematiques?.length > 0 && <p><span className="font-semibold">Problématiques :</span> {prospect.problematiques.join(', ')}</p>}
                {prospect.objectifContact && <p><span className="font-semibold">Objectif :</span> {prospect.objectifContact}</p>}
                {prospect.historiqueMails?.length > 0 && <p><span className="font-semibold">Mails précédents :</span> {prospect.historiqueMails.length}</p>}
              </div>
              <button onClick={handleGenerer} disabled={generation}
                className="w-full flex items-center justify-center gap-2 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50">
                {generation ? <><RefreshCw size={18} className="animate-spin" /> SENTINELLE rédige...</> : <><Sparkles size={18} /> Générer le mail</>}
              </button>
              {erreur && <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700">{erreur}</div>}
            </>
          )}
          {resultat && (
            <>
              <p className="text-xs font-semibold text-gray-400 uppercase">Objet</p>
              <p className="text-sm font-semibold text-gray-800 bg-gray-50 rounded-lg px-3 py-2">{resultat.objet}</p>
              <div className="border rounded-lg overflow-hidden" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <iframe srcDoc={resultat.contenuHtml} title="Prévisualisation mail" className="w-full border-0" style={{ minHeight: '300px' }} />
              </div>
              {ouvert ? (
                <div className="flex flex-col gap-3">
                  <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-3 flex items-center gap-2">
                    <Check size={16} className="text-emerald-600 shrink-0" />
                    <p className="text-sm text-emerald-700 font-medium">Gmail ouvert — brouillon enregistré.</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 mb-1.5">Collez ici le contenu <strong>réellement envoyé</strong> depuis Gmail (ou laissez tel quel si identique) :</p>
                    <textarea
                      value={contenuFinal}
                      onChange={(e) => setContenuFinal(e.target.value)}
                      rows={8}
                      className="w-full text-sm text-gray-700 border border-gray-200 rounded-lg p-3 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-400"
                    />
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={async () => {
                        if (!onMarquerEnvoye || !brouillonId) { onMailGenere(); return; }
                        setMarquerEnCours(true);
                        await onMarquerEnvoye(brouillonId, contenuFinal);
                        setMarquerEnCours(false);
                        onMailGenere(); // déclenche charger() dans le parent + ferme la modale
                      }}
                      disabled={marquerEnCours}
                      className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50 text-sm"
                    >
                      <CheckCircle size={16} /> {marquerEnCours ? 'Archivage…' : 'Archiver comme envoyé'}
                    </button>
                    <button onClick={onFermer} className="px-4 py-2.5 bg-gray-100 text-gray-600 rounded-lg text-sm hover:bg-gray-200">
                      Fermer
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="flex gap-2">
                    <button onClick={handleOuvrirGmail} disabled={!prospect.contactEmail}
                      className="flex-1 flex items-center justify-center gap-2 py-2.5 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50 text-sm">
                      <ExternalLink size={16} /> Ouvrir dans Gmail
                    </button>
                    <button onClick={handleEnregistrer}
                      className="flex items-center gap-2 py-2.5 px-4 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 text-sm">
                      <Check size={16} /> Brouillon
                    </button>
                  </div>
                  <button onClick={() => { const texte = `Objet : ${resultat.objet}\n\n${resultat.contenuTexte}`; navigator.clipboard.writeText(texte).then(() => { setCopie(true); setTimeout(() => setCopie(false), 2000); }); }}
                    className="w-full flex items-center justify-center gap-2 py-2 text-gray-500 hover:text-gray-700 text-sm">
                    <Copy size={14} /> {copie ? 'Copié !' : 'Copier le texte'}
                  </button>
                  <button onClick={() => { setResultat(null); setErreur(''); }}
                    className="w-full flex items-center justify-center gap-2 py-2 text-gray-400 hover:text-gray-600 text-sm">
                    <RotateCcw size={14} /> Régénérer
                  </button>
                  {erreur && <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700">{erreur}</div>}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// ============================================
// MODAL DÉPÔT DOCUMENT
// ============================================

interface ModalDepotDocumentProps {
  onFermer: () => void;
  onDeposer: (fichier: File, type: TypeDocumentProspect, nom: string) => Promise<void>;
}

const ModalDepotDocument: React.FC<ModalDepotDocumentProps> = ({ onFermer, onDeposer }) => {
  const [fichier, setFichier] = useState<File | null>(null);
  const [type, setType] = useState<TypeDocumentProspect>('reponse_recue');
  const [nom, setNom] = useState('');
  const [dragOver, setDragOver] = useState(false);
  const [depot, setDepot] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFichier = (f: File) => {
    setFichier(f);
    if (!nom) {
      const nomAuto = f.name.replace(/\.pdf$/i, '').replace(/[-_]/g, ' ');
      setNom(nomAuto);
    }
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setDragOver(false);
    const f = e.dataTransfer.files[0];
    if (f && f.type === 'application/pdf') handleFichier(f);
  };

  const handleDeposer = async () => {
    if (!fichier || !nom.trim()) return;
    setDepot(true);
    try {
      await onDeposer(fichier, type, nom.trim());
      onFermer();
    } finally {
      setDepot(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-[60] flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-bold text-gray-800">Déposer un document</h2>
          <button onClick={onFermer} className="p-1 hover:bg-gray-100 rounded"><X size={20} /></button>
        </div>
        <div className="p-4 space-y-4">
          {/* Dropzone */}
          <div
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={handleDrop}
            onClick={() => inputRef.current?.click()}
            className={`border-2 border-dashed rounded-xl p-6 text-center cursor-pointer transition-colors ${
              dragOver ? 'border-blue-400 bg-blue-50' : fichier ? 'border-emerald-400 bg-emerald-50' : 'border-gray-300 hover:border-gray-400'
            }`}>
            <input ref={inputRef} type="file" accept=".pdf" className="hidden"
              onChange={(e) => { const f = e.target.files?.[0]; if (f) handleFichier(f); }} />
            {fichier ? (
              <div className="flex items-center justify-center gap-3">
                <FileText size={28} className="text-emerald-600" />
                <div className="text-left">
                  <p className="text-sm font-semibold text-emerald-700">{fichier.name}</p>
                  <p className="text-xs text-emerald-600">{formatTaille(fichier.size)}</p>
                </div>
              </div>
            ) : (
              <>
                <Upload size={28} className="text-gray-400 mx-auto mb-2" />
                <p className="text-sm text-gray-600 font-semibold">Glissez un PDF ici</p>
                <p className="text-xs text-gray-400 mt-1">ou cliquez pour sélectionner</p>
              </>
            )}
          </div>

          {/* Type de document */}
          <div>
            <label className="block text-xs text-gray-500 mb-2">Type de document</label>
            <div className="grid grid-cols-2 gap-2">
              {(['reponse_recue', 'proposition', 'compte_rendu', 'autre'] as TypeDocumentProspect[]).map((t) => (
                <button key={t} type="button" onClick={() => setType(t)}
                  className={`px-3 py-2 rounded-lg text-xs font-semibold border-2 transition-colors text-left ${
                    type === t ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-gray-200 text-gray-600 hover:border-gray-300'
                  }`}>
                  {LABELS_TYPE_DOCUMENT_PROSPECT[t]}
                </button>
              ))}
            </div>
          </div>

          {/* Nom */}
          <div>
            <label className="block text-xs text-gray-500 mb-1">Nom affiché *</label>
            <input type="text" value={nom} onChange={(e) => setNom(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
              placeholder="Ex : Réponse ARC 07/03/2026" />
          </div>
        </div>
        <div className="flex justify-end gap-3 p-4 border-t bg-gray-50 rounded-b-xl">
          <button onClick={onFermer} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-200 rounded-lg">Annuler</button>
          <button onClick={handleDeposer} disabled={!fichier || !nom.trim() || depot}
            className="flex items-center gap-2 px-6 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 disabled:opacity-50">
            {depot ? <><RefreshCw size={16} className="animate-spin" /> Dépôt...</> : <><Upload size={16} /> Déposer</>}
          </button>
        </div>
      </div>
    </div>
  );
};

// ============================================
// MODAL IMPORT RÉPONSE ENTRANTE — SESSION 206
// Dropzone PDF simple — pas de saisie de nom (auto depuis nom de fichier)
// ============================================

interface ModalImportReponseProps {
  onFermer: () => void;
  onImporter: (fichier: File) => Promise<void>;
}

const ModalImportReponse: React.FC<ModalImportReponseProps> = ({ onFermer, onImporter }) => {
  const [fichier, setFichier] = useState<File | null>(null);
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFichier = (f: File) => { if (f.type === 'application/pdf') setFichier(f); };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setDragOver(false);
    const f = e.dataTransfer.files[0];
    if (f) handleFichier(f);
  };

  const handleImporter = async () => {
    if (!fichier) return;
    await onImporter(fichier);
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-[60] flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between p-4 border-b">
          <div>
            <h2 className="text-lg font-bold text-gray-800">Importer une réponse reçue</h2>
            <p className="text-xs text-gray-500 mt-0.5">Exportez le mail depuis Gmail en PDF, puis déposez-le ici</p>
          </div>
          <button onClick={onFermer} className="p-1 hover:bg-gray-100 rounded"><X size={20} /></button>
        </div>
        <div className="p-4 space-y-4">
          <div
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={handleDrop}
            onClick={() => inputRef.current?.click()}
            className={`border-2 border-dashed rounded-xl p-8 text-center cursor-pointer transition-colors ${
              dragOver ? 'border-emerald-400 bg-emerald-50' : fichier ? 'border-emerald-400 bg-emerald-50' : 'border-gray-300 hover:border-gray-400'
            }`}>
            <input ref={inputRef} type="file" accept=".pdf" className="hidden"
              onChange={(e) => { const f = e.target.files?.[0]; if (f) handleFichier(f); }} />
            {fichier ? (
              <div className="flex items-center justify-center gap-3">
                <FileText size={32} className="text-emerald-600" />
                <div className="text-left">
                  <p className="text-sm font-semibold text-emerald-700">{fichier.name}</p>
                  <p className="text-xs text-emerald-600">{formatTaille(fichier.size)}</p>
                </div>
              </div>
            ) : (
              <>
                <ArrowDownLeft size={32} className="text-gray-400 mx-auto mb-2" />
                <p className="text-sm text-gray-600 font-semibold">Glissez le PDF de la réponse ici</p>
                <p className="text-xs text-gray-400 mt-1">ou cliquez pour sélectionner</p>
              </>
            )}
          </div>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
            <p className="text-xs text-blue-700">
              <strong>Comment exporter un mail Gmail en PDF ?</strong><br />
              Ouvrir le mail → menu ⋮ → Imprimer → choisir "Enregistrer au format PDF" comme imprimante.
            </p>
          </div>
        </div>
        <div className="flex justify-end gap-3 p-4 border-t bg-gray-50 rounded-b-xl">
          <button onClick={onFermer} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-200 rounded-lg">Annuler</button>
          <button onClick={handleImporter} disabled={!fichier}
            className="flex items-center gap-2 px-6 py-2 bg-emerald-600 text-white text-sm font-semibold rounded-lg hover:bg-emerald-700 disabled:opacity-50">
            <ArrowDownLeft size={16} /> Importer et analyser
          </button>
        </div>
      </div>
    </div>
  );
};

// ============================================
// MARKDOWN RENDERER — rendu des réponses SENTINELLE
// ============================================

const MarkdownMessage: React.FC<{ content: string; dark?: boolean }> = ({ content, dark = false }) => {
  const base = dark ? 'text-white' : 'text-gray-800';
  const muted = dark ? 'text-blue-200' : 'text-gray-500';
  const bld = dark ? 'text-white font-bold' : 'text-gray-900 font-bold';
  const h3color = dark ? 'text-white font-bold text-sm' : 'text-gray-900 font-bold text-sm';
  const sep = dark ? 'border-blue-400' : 'border-gray-300';
  const codeBg = dark ? 'bg-blue-800 text-blue-100' : 'bg-gray-100 text-gray-800';

  const renderInline = (text: string, key: string): React.ReactNode => {
    const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g);
    return (
      <span key={key}>
        {parts.map((part, idx) => {
          if (part.startsWith('**') && part.endsWith('**'))
            return <strong key={idx} className={bld}>{part.slice(2, -2)}</strong>;
          if (part.startsWith('*') && part.endsWith('*'))
            return <em key={idx}>{part.slice(1, -1)}</em>;
          if (part.startsWith('`') && part.endsWith('`'))
            return <code key={idx} className={`px-1 rounded text-xs font-mono ${codeBg}`}>{part.slice(1, -1)}</code>;
          return part;
        })}
      </span>
    );
  };

  const lines = content.split('\n');
  const elements: React.ReactNode[] = [];
  let i = 0;

  while (i < lines.length) {
    const line = lines[i];
    if (line.trim() === '') { elements.push(<div key={`br-${i}`} className="h-2" />); i++; continue; }
    if (/^---+$/.test(line.trim())) { elements.push(<hr key={`hr-${i}`} className={`my-2 border-t ${sep}`} />); i++; continue; }
    if (line.startsWith('### ')) { elements.push(<p key={`h3-${i}`} className={`mt-2 mb-1 ${h3color}`}>{renderInline(line.slice(4), `h3c-${i}`)}</p>); i++; continue; }
    if (line.startsWith('## ')) { elements.push(<p key={`h2-${i}`} className={`mt-2 mb-1 font-bold text-xs uppercase tracking-wide ${muted}`}>{renderInline(line.slice(3), `h2c-${i}`)}</p>); i++; continue; }
    if (line.startsWith('# ')) { elements.push(<p key={`h1-${i}`} className={`mt-1 mb-1 font-bold ${bld}`}>{renderInline(line.slice(2), `h1c-${i}`)}</p>); i++; continue; }
    if (/^\d+\.\s/.test(line)) {
      const items: React.ReactNode[] = [];
      while (i < lines.length && /^\d+\.\s/.test(lines[i])) {
        const num = lines[i].match(/^(\d+)\.\s/)?.[1];
        const txt = lines[i].replace(/^\d+\.\s/, '');
        items.push(<li key={`oli-${i}`} className="flex gap-2 items-start"><span className={`flex-shrink-0 font-bold text-xs mt-0.5 ${muted}`}>{num}.</span><span className="text-sm">{renderInline(txt, `olic-${i}`)}</span></li>);
        i++;
      }
      elements.push(<ol key={`ol-${i}`} className={`space-y-1 my-1 ${base}`}>{items}</ol>);
      continue;
    }
    if (/^[-*•]\s/.test(line)) {
      const items: React.ReactNode[] = [];
      while (i < lines.length && /^[-*•]\s/.test(lines[i])) {
        const txt = lines[i].replace(/^[-*•]\s/, '');
        items.push(<li key={`uli-${i}`} className="flex gap-2 items-start"><span className={`flex-shrink-0 mt-2 w-1 h-1 rounded-full ${dark ? 'bg-blue-300' : 'bg-gray-400'}`} /><span className="text-sm">{renderInline(txt, `ulic-${i}`)}</span></li>);
        i++;
      }
      elements.push(<ul key={`ul-${i}`} className={`space-y-1 my-1 ${base}`}>{items}</ul>);
      continue;
    }
    elements.push(<p key={`p-${i}`} className={`text-sm leading-relaxed ${base}`}>{renderInline(line, `pc-${i}`)}</p>);
    i++;
  }

  return <div className="space-y-0.5">{elements}</div>;
};

// ============================================
// BULLE MAIL SENTINELLE — affichage inline dans le chat
// ============================================

interface BulleMailProps {
  mail: MailSentinelle;
  prospect: Prospect;
  onMailEnvoye: () => void;
}

const BulleMailSentinelle: React.FC<BulleMailProps> = ({ mail, prospect, onMailEnvoye }) => {
  const [copie, setCopie] = useState(false);
  const [enregistre, setEnregistre] = useState(false);

  const corpsNettoye = mail.corps.replace(/\\n/g, '\n');

  const handleOuvrirGmail = async () => {
    // Ouvre Gmail avec le mail pré-rempli — l'utilisateur relit et envoie lui-même
    const to = encodeURIComponent(prospect.contactEmail || '');
    const subject = encodeURIComponent(mail.objet);
    const body = encodeURIComponent(corpsNettoye);
    window.open(`https://mail.google.com/mail/?view=cm&to=${to}&su=${subject}&body=${body}`, '_blank');

    // Enregistrer en brouillon dans l'historique
    try {
      await ajouterHistoriqueMail(prospect.id, {
        objet: mail.objet,
        template: 'libre',
        destinataire: prospect.contactEmail || '',
        auteur: prospect.responsable,
        envoye: false,
        apercu: corpsNettoye.substring(0, 200),
        contenuHtml: corpsNettoye,
      });
      setEnregistre(true);
      onMailEnvoye();
    } catch {
      // Non bloquant — Gmail s'ouvre quand même
    }
  };

  const handleCopier = () => {
    const texte = `Objet : ${mail.objet}\n\n${corpsNettoye}`;
    navigator.clipboard.writeText(texte).then(() => {
      setCopie(true);
      setTimeout(() => setCopie(false), 2000);
    });
  };

  return (
    <div className="flex justify-start">
      <div className="max-w-[90%] w-full">
        <div className="bg-blue-50 border border-blue-200 rounded-2xl rounded-bl-sm overflow-hidden">
          {/* Header */}
          <div className="flex items-center gap-2 px-3.5 py-2 bg-blue-100 border-b border-blue-200">
            <Mail size={13} className="text-blue-600 flex-shrink-0" />
            <span className="text-xs font-semibold text-blue-700">Mail généré par SENTINELLE</span>
            {enregistre && (
              <span className="ml-auto text-[10px] text-emerald-600 font-medium flex items-center gap-1">
                <Check size={10} /> Enregistré
              </span>
            )}
          </div>
          {/* Objet */}
          <div className="px-3.5 pt-2.5 pb-1">
            <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-0.5">Objet</p>
            <p className="text-sm font-semibold text-gray-800">{mail.objet}</p>
          </div>
          {/* Corps */}
          <div className="px-3.5 pb-2.5 pt-1">
            <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-1">Corps</p>
            <p className="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">{corpsNettoye}</p>
          </div>
          {/* Actions */}
          <div className="px-3.5 pb-3 pt-1 flex items-center gap-2 border-t border-blue-100">
            <button
              onClick={handleOuvrirGmail}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold rounded-lg transition-colors"
            >
              <ExternalLink size={12} />
              Ouvrir dans Gmail
            </button>
            <button
              onClick={handleCopier}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-white hover:bg-gray-50 text-gray-600 text-xs font-semibold rounded-lg border border-gray-200 transition-colors"
            >
              {copie ? <Check size={12} className="text-emerald-500" /> : <Copy size={12} />}
              {copie ? 'Copié !' : 'Copier'}
            </button>
            {!prospect.contactEmail && (
              <p className="text-[10px] text-amber-600 ml-1">Email destinataire manquant</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// ============================================
// PANNEAU SENTINELLE CRM — colonne droite
// ============================================

interface SentinelleCrmPanelProps {
  prospect: Prospect;
  onDocumentDepose: () => void;
  onMailGenere: () => void;
}

const SentinelleCrmPanel: React.FC<SentinelleCrmPanelProps> = ({ prospect, onDocumentDepose, onMailGenere }) => {
  const { userProfile } = useAuth();
  const [messages, setMessages] = useState<MessageConversationProspect[]>([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(true);
  const [envoi, setEnvoi] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const [showDepot, setShowDepot] = useState(false);
  const [confirmReinit, setConfirmReinit] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLTextAreaElement>(null);

  // Chargement de l'historique
  useEffect(() => {
    const charger = async () => {
      setLoading(true);
      try {
        const historique = await chargerConversationProspect(prospect.id);
        setMessages(historique);
      } finally {
        setLoading(false);
      }
    };
    charger();
  }, [prospect.id]);

  // Scroll automatique vers le bas
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // Contexte injecté dans chaque appel SENTINELLE
  const buildContexte = useCallback((): string => {
    const mails = prospect.historiqueMails || [];
    const dernierMail = mails.length > 0 ? mails[mails.length - 1] : null;

    // Notes de suivi — triées du plus récent au plus ancien, max 5
    const notes = [...(prospect.notes || [])]
      .sort((a, b) => (b.date?.seconds || 0) - (a.date?.seconds || 0))
      .slice(0, 5);
    const notesSection = notes.length > 0
      ? `\nNOTES DE SUIVI (${notes.length} dernière${notes.length > 1 ? 's' : ''}) :\n${notes.map((n) => {
          const d = n.date?.toDate?.() || new Date();
          const dateStr = d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
          return `- [${dateStr}] ${n.texte}`;
        }).join('\n')}`
      : '';

    return `
Tu es SENTINELLE, l'IA de Copro Protect, en mode CRM Prospection.
Tu accompagnes l'équipe commerciale dans la relation avec le prospect suivant :

PROSPECT :
- Nom : ${prospect.nom}
- Type : ${prospect.typeProspect}
- Segment : ${prospect.segment}
- Produit visé : ${prospect.typeCible}
- Statut pipeline : ${prospect.statut}
- Responsable : ${prospect.responsable}
${prospect.contactNom ? `- Contact : ${prospect.contactNom}` : ''}
${prospect.contactEmail ? `- Email : ${prospect.contactEmail}` : ''}
${prospect.tailleStructure ? `- Taille/Adhérents : ${prospect.tailleStructure}` : ''}
${prospect.objectifContact ? `- Objectif : ${prospect.objectifContact}` : ''}
${prospect.problematiques?.length > 0 ? `- Problématiques : ${prospect.problematiques.join(', ')}` : ''}
${prospect.prochaineAction ? `- Prochaine action : ${prospect.prochaineAction}` : ''}
${dernierMail ? `- Dernier mail : "${dernierMail.objet}" (${dernierMail.envoye ? 'envoyé' : 'brouillon'})` : ''}
${mails.length > 0 ? `- Nombre de mails échangés : ${mails.length}` : '- Aucun mail envoyé à ce jour'}
${notesSection}

RÔLE :
Tu analyses les documents déposés (réponses du prospect en PDF), tu proposes des actions concrètes (relance, changement d'étape, point de vigilance), et tu génères des mails si demandé.
Méthode SCUD : posture du béotien naïf, questions plutôt qu'affirmations, remercier avant de demander.
Réponses concises, orientées action. Pas de jargon technique.

FORMAT OBLIGATOIRE POUR LES MAILS :
Quand tu rédiges un mail (premier contact, relance, suivi, partenariat, ou tout autre mail), tu dois TOUJOURS retourner UNIQUEMENT ce JSON, sans texte avant ni après :
{"type":"mail","objet":"Objet du mail ici","corps":"Corps complet du mail ici, avec sauts de ligne \\n"}
Ne jamais mettre de markdown, de guillemets imbriqués, ni de texte hors du JSON quand tu génères un mail.
    `.trim();
  }, [prospect]);

  const envoyerMessage = async (texte: string, documentId?: string) => {
    if (!texte.trim() && !documentId) return;
    setEnvoi(true);

    // Message user
    const msgUser = await ajouterMessageConversation(prospect.id, 'user', texte.trim(), documentId);
    setMessages((prev) => [...prev, msgUser]);
    setInput('');

    try {
      // Construire l'historique pour l'API (sans le message courant — envoyé séparément)
      const historiqueApi = messages.map((m) => ({
        role: m.role,
        content: m.content,
      }));

      const functions = getFunctions(undefined, 'europe-west1');
      const askAssistantCrm = httpsCallable(functions, 'askAssistantCrm');

      const result = await askAssistantCrm({
        message: texte.trim(),
        systemPrompt: buildContexte(),
        conversationHistory: historiqueApi,
        prospectId: prospect.id,
      }) as { data: { response: string } };

      const reponse = result.data?.response || 'Je n\'ai pas pu générer de réponse.';

      // Persister + afficher la réponse
      const msgAssistant = await ajouterMessageConversation(prospect.id, 'assistant', reponse, documentId);
      setMessages((prev) => [...prev, msgAssistant]);
    } catch (err) {
      console.error('[SENTINELLE CRM] Erreur:', err);
      const msgErreur = await ajouterMessageConversation(
        prospect.id, 'assistant',
        'Une erreur est survenue. Merci de réessayer.'
      );
      setMessages((prev) => [...prev, msgErreur]);
    } finally {
      setEnvoi(false);
      inputRef.current?.focus();
    }
  };

  const handleDepotDocument = async (fichier: File, type: TypeDocumentProspect, nom: string) => {
    // Dépôt du fichier
    const auteur = userProfile?.prenom?.toLowerCase() || userProfile?.email?.split('@')[0] || 'admin';
    const document = await ajouterDocumentProspect(prospect.id, fichier, type, nom, auteur);
    onDocumentDepose();

    // Lire le PDF en base64 pour l'analyse SENTINELLE
    const base64 = await new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        resolve(result.split(',')[1]);
      };
      reader.readAsDataURL(fichier);
    });

    // Message d'amorce
    const texteAmorce = `J'ai déposé un document : "${nom}" (${LABELS_TYPE_DOCUMENT_PROSPECT[type]}). Analyse-le dans le contexte de ce prospect et dis-moi ce que tu en retiens.`;

    setEnvoi(true);
    const msgUser = await ajouterMessageConversation(prospect.id, 'user', texteAmorce, document.id);
    setMessages((prev) => [...prev, msgUser]);

    try {
      const functions = getFunctions(undefined, 'europe-west1');
      const askAssistantCrm = httpsCallable(functions, 'askAssistantCrm');

      const texteAnalyse = `Voici le contenu d'un document PDF déposé sur la fiche de ce prospect.\n\nNom du fichier : ${fichier.name}\nType : ${LABELS_TYPE_DOCUMENT_PROSPECT[type]}\n\nAnalyse ce document dans le contexte de ce prospect et dis-moi ce que tu en retiens : points clés, signaux d'intérêt ou de résistance, prochaine action recommandée.`;

      const result = await askAssistantCrm({
        message: texteAnalyse,
        systemPrompt: buildContexte(),
        conversationHistory: [],
        prospectId: prospect.id,
      }) as { data: { response: string } };

      const reponse = result.data?.response || 'Analyse terminée.';
      const msgAssistant = await ajouterMessageConversation(prospect.id, 'assistant', reponse, document.id);
      setMessages((prev) => [...prev, msgAssistant]);
    } catch (err) {
      console.error('[SENTINELLE CRM] Erreur analyse document:', err);
      const msgErreur = await ajouterMessageConversation(
        prospect.id, 'assistant',
        `Document "${nom}" déposé avec succès. Je n'ai pas pu l'analyser automatiquement — tu peux me poser des questions dessus directement.`
      );
      setMessages((prev) => [...prev, msgErreur]);
    } finally {
      setEnvoi(false);
    }
  };

  const handleReinit = async () => {
    await reinitialiserConversationProspect(prospect.id);
    setMessages([]);
    setConfirmReinit(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!envoi && input.trim()) envoyerMessage(input);
    }
  };

  return (
    <div className="flex flex-col h-full bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-blue-600 to-blue-700 flex-shrink-0">
        <div className="flex items-center gap-2 text-white">
          <Sparkles size={18} />
          <span className="font-bold text-sm">SENTINELLE</span>
          <span className="text-blue-200 text-xs">— {prospect.nom}</span>
        </div>
        <div className="flex items-center gap-1">
          <button
            onClick={() => setShowDepot(true)}
            title="Déposer un document"
            className="p-1.5 text-white/80 hover:text-white hover:bg-white/20 rounded-lg transition-colors">
            <Upload size={15} />
          </button>
          {confirmReinit ? (
            <div className="flex items-center gap-1 bg-white/10 rounded-lg px-2 py-1">
              <span className="text-white text-xs">Effacer ?</span>
              <button onClick={handleReinit} className="text-xs bg-white/30 hover:bg-white/40 text-white px-2 py-0.5 rounded">Oui</button>
              <button onClick={() => setConfirmReinit(false)} className="text-xs text-white/70 hover:text-white px-1">Non</button>
            </div>
          ) : (
            <button
              onClick={() => setConfirmReinit(true)}
              title="Réinitialiser la conversation"
              className="p-1.5 text-white/60 hover:text-white hover:bg-white/20 rounded-lg transition-colors">
              <RotateCw size={14} />
            </button>
          )}
        </div>
      </div>

      {/* Messages */}
      <div
        className="flex-1 overflow-y-auto p-4 space-y-3"
        onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDragOver(false);
          const f = e.dataTransfer.files[0];
          if (f && f.type === 'application/pdf') setShowDepot(true);
        }}>

        {loading ? (
          <div className="flex justify-center py-8">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600" />
          </div>
        ) : messages.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-10 text-center">
            <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mb-3">
              <Sparkles size={22} className="text-blue-600" />
            </div>
            <p className="text-sm font-semibold text-gray-700">SENTINELLE prête</p>
            <p className="text-xs text-gray-400 mt-1 max-w-[200px]">
              Pose une question sur ce prospect ou dépose une réponse PDF reçue
            </p>
            <div className="mt-4 space-y-2 w-full">
              {SUGGESTIONS_PAR_STATUT[prospect.statut]?.map((s) => (
                <button key={s} onClick={() => envoyerMessage(s)}
                  className="w-full text-left px-3 py-2 bg-gray-50 hover:bg-blue-50 border border-gray-200 hover:border-blue-300 rounded-lg text-xs text-gray-600 hover:text-blue-700 transition-colors">
                  {s}
                </button>
              ))}
            </div>
          </div>
        ) : (
          messages.map((msg) => {
            // Détection mail JSON retourné par SENTINELLE
            const mailParse = msg.role === 'assistant' ? parserMailSentinelle(msg.content) : null;

            if (mailParse) {
              // Bulle enrichie pour un mail généré
              return (
                <BulleMailSentinelle
                  key={msg.id}
                  mail={mailParse}
                  prospect={prospect}
                  onMailEnvoye={onMailGenere}
                />
              );
            }

            return (
              <div key={msg.id} className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}>
                <div className={`max-w-[85%] rounded-2xl px-3.5 py-2.5 text-sm ${
                  msg.role === 'user'
                    ? 'bg-blue-600 text-white rounded-br-sm'
                    : 'bg-gray-100 text-gray-800 rounded-bl-sm'
                }`}>
                  {msg.documentId && (
                    <div className={`flex items-center gap-1.5 mb-1.5 pb-1.5 border-b text-xs ${
                      msg.role === 'user' ? 'border-blue-400 text-blue-200' : 'border-gray-300 text-gray-500'
                    }`}>
                      <FileText size={11} />
                      <span>Document joint</span>
                    </div>
                  )}
                  <MarkdownMessage content={msg.content} dark={msg.role === 'user'} />
                </div>
              </div>
            );
          })
        )}

        {envoi && (
          <div className="flex justify-start">
            <div className="bg-gray-100 rounded-2xl rounded-bl-sm px-4 py-3">
              <div className="flex gap-1">
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
                <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
              </div>
            </div>
          </div>
        )}

        {dragOver && (
          <div className="absolute inset-0 bg-blue-500/10 border-2 border-dashed border-blue-400 rounded-xl flex items-center justify-center pointer-events-none">
            <p className="text-blue-600 font-semibold text-sm">Déposer le PDF ici</p>
          </div>
        )}

        <div ref={messagesEndRef} />
      </div>

      {/* Input */}
      <div className="flex-shrink-0 border-t p-3 bg-gray-50">
        <div className="flex items-end gap-2">
          <textarea
            ref={inputRef}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            rows={1}
            placeholder="Message à SENTINELLE..."
            className="flex-1 px-3 py-2 text-sm border border-gray-200 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            style={{ minHeight: '38px', maxHeight: '120px' }}
          />
          <button
            onClick={() => envoyerMessage(input)}
            disabled={!input.trim() || envoi}
            className="p-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 disabled:opacity-40 transition-colors flex-shrink-0">
            <Send size={16} />
          </button>
        </div>
        <p className="text-[10px] text-gray-400 mt-1.5 text-center">
          Entrée pour envoyer · Shift+Entrée pour sauter une ligne
        </p>
      </div>

      {/* Modal dépôt document */}
      {showDepot && (
        <ModalDepotDocument
          onFermer={() => setShowDepot(false)}
          onDeposer={handleDepotDocument}
        />
      )}
    </div>
  );
};

// ============================================
// PAGE PRINCIPALE
// ============================================

const CrmProspectDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  const isApporteur = userProfile?.role === 'apporteur' || !!userProfile?.apporteurInfo?.identifiant;
  const retourCrm = isApporteur ? '/apporteur/pipeline' : '/admin-saas/crm';

  const [prospect, setProspect] = useState<Prospect | null>(null);
  const [responsables, setResponsables] = useState<InfoResponsable[]>([]);
  const [documents, setDocuments] = useState<DocumentProspect[]>([]);
  const [loading, setLoading] = useState(true);
  const [showEdition, setShowEdition] = useState(false);
  const [showModaleMail, setShowModaleMail] = useState(false);
  const [nouvelleNote, setNouvelleNote] = useState('');
  const [noteEnEdition, setNoteEnEdition] = useState<string | null>(null); // id de la note en cours d'édition
  const [texteEditionNote, setTexteEditionNote] = useState('');
  const [ajoutEnCours, setAjoutEnCours] = useState(false);
  const [confirmSupp, setConfirmSupp] = useState(false);
  const [confirmSuppMail, setConfirmSuppMail] = useState<string | null>(null); // mailId en attente de confirmation
  const [suppressionMailEnCours, setSuppressionMailEnCours] = useState(false);
  const [marquerEnvoyeEnCours, setMarquerEnvoyeEnCours] = useState(false);
  // Modale "Marquer comme envoyé" — contenu éditable avant archivage
  const [modaleMarquerEnvoye, setModaleMarquerEnvoye] = useState<{ mailId: string; contenu: string } | null>(null);
  const [changementStatut, setChangementStatut] = useState(false);
  const [confirmSuppDoc, setConfirmSuppDoc] = useState<string | null>(null);
  // Session 206 — import réponse entrante
  const [showImportReponse, setShowImportReponse] = useState(false);
  const [importEnCours, setImportEnCours] = useState(false);
  const [brouillonRelanceMailId, setBrouillonRelanceMailId] = useState<string | null>(null);
  const [mailDetail, setMailDetail] = useState<HistoriqueMailProspect | null>(null);
  const [mailDetailTexte, setMailDetailTexte] = useState<string>('');
  const [mailDetailEnvoiOk, setMailDetailEnvoiOk] = useState(false);

  const charger = async () => {
    if (!id) return;
    setLoading(true);
    try {
      if (isApporteur) {
        // Apporteur : lecture directe par ID (permissions Firestore filtrées par responsable)
        // chargerResponsables() nécessite un accès à users/ non autorisé pour les apporteurs
        const [found, docs] = await Promise.all([
          chargerProspectParId(id),
          chargerDocumentsProspect(id),
        ]);
        setProspect(found);
        setResponsables([]);
        setDocuments(docs);
      } else {
        const [prospects, resp, docs] = await Promise.all([
          chargerProspects(),
          chargerResponsables(),
          chargerDocumentsProspect(id),
        ]);
        const found = prospects.find((p) => p.id === id);
        setProspect(found || null);
        setResponsables(resp);
        setDocuments(docs);
      }
    } catch (err) {
      console.error('[CRM] Erreur chargement prospect:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { charger(); }, [id]);

  const handleSauvegarder = async (data: Partial<Prospect>) => {
    if (!prospect) return;
    await mettreAJourProspect(prospect.id, data as Record<string, unknown>);
    await charger();
  };

  const handleAjouterNote = async () => {
    if (!prospect || !nouvelleNote.trim()) return;
    setAjoutEnCours(true);
    try {
      const auteur = responsables.length > 0 ? responsables[0].identifiant : 'admin';
      await ajouterNote(prospect.id, nouvelleNote.trim(), auteur);
      setNouvelleNote('');
      await charger();
    } finally {
      setAjoutEnCours(false);
    }
  };

  const handleSupprimerNote = async (noteId: string) => {
    if (!prospect) return;
    await supprimerNote(prospect.id, noteId);
    await charger();
  };

  const handleValiderEditionNote = async () => {
    if (!prospect || !noteEnEdition || !texteEditionNote.trim()) return;
    await modifierNote(prospect.id, noteEnEdition, texteEditionNote.trim());
    setNoteEnEdition(null);
    setTexteEditionNote('');
    await charger();
  };

  const handleSupprimer = async () => {
    if (!prospect) return;
    await supprimerProspect(prospect.id);
    navigate(retourCrm);
  };

  const handleChangerStatut = async (nouveauStatut: StatutProspect) => {
    if (!prospect) return;
    setChangementStatut(true);
    try {
      await changerStatutProspect(prospect.id, nouveauStatut);
      await charger();
    } finally {
      setChangementStatut(false);
    }
  };

  const handleRapprocher = async () => {
    if (!prospect) return;
    const result = await rapprocherProspectUser(prospect.id);
    if (result.found) {
      alert(`Client trouvé ! Formule : ${result.formule}`);
      await charger();
    } else {
      alert('Aucun compte Copro Protect trouvé avec cet email.');
    }
  };

  const handleSupprimerDocument = async (doc: DocumentProspect) => {
    if (!prospect) return;
    await supprimerDocumentProspect(prospect.id, doc);
    setDocuments((prev) => prev.filter((d) => d.id !== doc.id));
    setConfirmSuppDoc(null);
  };

  const handleSupprimerMail = async (mailId: string) => {
    if (!prospect) return;
    setSuppressionMailEnCours(true);
    try {
      await supprimerMailHistorique(prospect.id, mailId);
      await charger();
    } catch (err) {
      console.error('[CRM] Erreur suppression mail:', err);
    } finally {
      setSuppressionMailEnCours(false);
      setConfirmSuppMail(null);
    }
  };

  const handleMarquerEnvoye = (mailId: string) => {
    if (!prospect) return;
    // Trouver le mail dans l'historique pour pré-remplir le contenu
    const mail = prospect.historiqueMails?.find(m => m.id === mailId);
    const contenuInitial = mail?.apercu || '';
    setModaleMarquerEnvoye({ mailId, contenu: contenuInitial });
  };

  const handleConfirmerEnvoye = async () => {
    if (!prospect || !modaleMarquerEnvoye) return;
    setMarquerEnvoyeEnCours(true);
    try {
      await marquerMailEnvoye(prospect.id, modaleMarquerEnvoye.mailId, modaleMarquerEnvoye.contenu);
      await charger();
      setModaleMarquerEnvoye(null);
    } catch (err) {
      console.error('[CRM] Erreur marquage envoyé:', err);
    } finally {
      setMarquerEnvoyeEnCours(false);
    }
  };

  // Session 206 — Import réponse entrante + analyse SENTINELLE
  const handleImporterReponse = async (fichier: File) => {
    if (!prospect) return;
    setImportEnCours(true);
    setShowImportReponse(false);

    const auteur = 'admin';

    try {
      // 1. Upload PDF + entrée 'recu' dans historiqueMails
      const { mailId } = await importerReponseProspect(prospect.id, fichier, auteur);

      // 2. Lire le PDF en base64 pour l'analyse SENTINELLE
      const pdfBase64 = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve((reader.result as string).split(',')[1]);
        reader.onerror = () => reject(new Error('Lecture PDF échouée'));
        reader.readAsDataURL(fichier);
      });

      // 3. Construire le contexte prospect + dernier mail envoyé
      const mailsEnvoyes = (prospect.historiqueMails || []).filter(
        (m) => m.envoye && m.type !== 'recu'
      );
      const dernierMailEnvoye = mailsEnvoyes.length > 0
        ? {
            objet: mailsEnvoyes[mailsEnvoyes.length - 1].objet,
            template: mailsEnvoyes[mailsEnvoyes.length - 1].template,
            apercu: mailsEnvoyes[mailsEnvoyes.length - 1].apercu,
          }
        : null;

      const prospectContext = {
        nom: prospect.nom,
        typeProspect: prospect.typeProspect,
        segment: prospect.segment,
        typeCible: prospect.typeCible,
        contactNom: prospect.contactNom,
        tailleStructure: prospect.tailleStructure,
        objectifContact: prospect.objectifContact,
        problematiques: prospect.problematiques,
        statut: prospect.statut,
      };

      // 4. Appeler analyserReponseProspect (nouvelle Cloud Function dédiée)
      const functions = getFunctions(undefined, 'europe-west1');
      const analyserReponse = httpsCallable(functions, 'analyserReponseProspect');

      const result = await analyserReponse({
        prospectId: prospect.id,
        pdfBase64,
        prospectContext,
        dernierMailEnvoye,
      }) as { data: { analyse: AnalyseReponseProspect } };

      const analyse = result.data?.analyse;
      if (!analyse) throw new Error('Analyse vide retournée par SENTINELLE');

      // 5. Persister l'analyse sur le mail
      await enregistrerAnalyseReponse(prospect.id, mailId, analyse);

      // 6. Si brouillon de relance disponible, mémoriser l'id pour la modal
      if (analyse.brouillonRelance) {
        setBrouillonRelanceMailId(mailId);
      }

      // 7. Recharger le prospect pour afficher la timeline à jour
      await charger();
    } catch (err) {
      console.error('[CRM] Erreur import réponse:', err);
      alert('Une erreur est survenue lors de l\'import. Vérifiez la console.');
      await charger();
    } finally {
      setImportEnCours(false);
    }
  };


  if (loading) {
    return (
      <div className="flex items-center justify-center h-full py-20">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600" />
      </div>
    );
  }

  if (!prospect) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <p className="text-gray-500 mb-4">Prospect introuvable.</p>
        <button onClick={() => navigate(retourCrm)}
          className="flex items-center gap-2 px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 font-semibold">
          <ArrowLeft size={16} /> Retour au CRM
        </button>
      </div>
    );
  }

  // Timeline : mails + notes fusionnés, triés anti-chronologiquement
  type EvenementTimeline =
    | { type: 'note'; date: Date; data: NoteSuivi }
    | { type: 'mail'; date: Date; data: HistoriqueMailProspect };

  const evenements: EvenementTimeline[] = [
    ...(prospect.notes || []).map((note) => {
      let date = new Date(0);
      try { date = note.date?.toDate?.() || new Date(note.date as unknown as string); } catch { /* */ }
      return { type: 'note' as const, date, data: note };
    }),
    ...(prospect.historiqueMails || []).map((mail) => {
      let date = new Date(0);
      try { date = mail.date?.toDate?.() || new Date(mail.date as unknown as string); } catch { /* */ }
      return { type: 'mail' as const, date, data: mail };
    }),
  ].sort((a, b) => b.date.getTime() - a.date.getTime());

  return (
    <div className="flex flex-col h-full">

      {/* ---- HEADER ---- */}
      <div className="flex items-center justify-between px-6 py-4 border-b bg-white flex-shrink-0">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(retourCrm)}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors">
            <ArrowLeft size={20} />
          </button>
          <div className="flex items-center gap-2">
            {ICONES_TYPE_PROSPECT[prospect.typeProspect]}
            <div>
              <h1 className="text-xl font-bold text-gray-800 leading-tight">{prospect.nom}</h1>
              <div className="flex items-center gap-2 mt-0.5">
                <span className="text-xs text-gray-500">{LABELS_TYPE_PROSPECT[prospect.typeProspect]}</span>
                <ChevronRight size={12} className="text-gray-300" />
                <span className={`text-xs font-semibold px-2 py-0.5 rounded-full border ${COULEURS_SEGMENT_PROSPECT[prospect.segment]}`}>
                  {LABELS_SEGMENT_PROSPECT[prospect.segment]}
                </span>
                <ChevronRight size={12} className="text-gray-300" />
                <span className="text-xs font-semibold text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded-full border border-emerald-200">
                  {LABELS_STATUT_PROSPECT[prospect.statut]}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => setShowEdition(true)}
            className="flex items-center gap-2 px-3 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 font-semibold text-sm transition-colors">
            <Edit3 size={15} /> Modifier
          </button>

          {!isApporteur && (
            confirmSupp ? (
              <div className="flex items-center gap-2 bg-red-50 px-3 py-2 rounded-lg border border-red-200">
                <span className="text-xs text-red-600 font-semibold">Supprimer ?</span>
                <button onClick={handleSupprimer} className="px-3 py-1 bg-red-600 text-white text-xs rounded hover:bg-red-700">Oui</button>
                <button onClick={() => setConfirmSupp(false)} className="px-3 py-1 bg-gray-200 text-xs rounded hover:bg-gray-300">Non</button>
              </div>
            ) : (
              <button onClick={() => setConfirmSupp(true)}
                className="p-2 text-red-300 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors">
                <Trash2 size={18} />
              </button>
            )
          )}
        </div>
      </div>

      {/* ---- BODY 3 COLONNES ---- */}
      <div className="flex-1 overflow-hidden grid grid-cols-1 lg:grid-cols-3 gap-0">

        {/* ===== COLONNE GAUCHE — Dossier prospect ===== */}
        <div className="overflow-y-auto p-4 space-y-4 border-r border-gray-100 bg-gray-50">

          {/* Statut pipeline */}
          <div className="bg-white rounded-xl shadow-sm p-4">
            <p className="text-xs font-semibold text-gray-400 uppercase mb-3">Statut pipeline</p>
            <div className="flex flex-wrap gap-2">
              {COLONNES_KANBAN.map((statut) => (
                <button key={statut} onClick={() => handleChangerStatut(statut)} disabled={changementStatut}
                  className={`px-3 py-1.5 rounded-lg text-xs font-semibold border-2 transition-colors ${
                    prospect.statut === statut
                      ? 'border-emerald-500 bg-emerald-50 text-emerald-700'
                      : 'border-gray-200 text-gray-500 hover:border-gray-300 hover:bg-gray-50'
                  }`}>
                  {LABELS_STATUT_PROSPECT[statut]}
                </button>
              ))}
            </div>
            <div className="mt-3 pt-3 border-t flex items-center gap-2 text-sm">
              <span className="text-gray-400 text-xs">Responsable</span>
              <span className={`font-semibold px-2 py-0.5 rounded text-xs ${getCouleurResponsable(prospect.responsable, responsables)}`}>
                {getLabelResponsable(prospect.responsable, responsables)}
              </span>
            </div>
          </div>

          {/* Produit visé */}
          <div className="bg-white rounded-xl shadow-sm p-4">
            <p className="text-xs font-semibold text-gray-400 uppercase mb-2">Produit visé</p>
            <p className="text-sm font-semibold text-gray-700">{LABELS_TYPE_CIBLE[prospect.typeCible]}</p>
          </div>

          {/* Contact */}
          <div className="bg-white rounded-xl shadow-sm p-4">
            <p className="text-xs font-semibold text-gray-400 uppercase mb-3">Contact</p>
            <div className="space-y-2">
              {prospect.contactNom && <p className="text-sm text-gray-700 flex items-center gap-2"><User size={14} className="text-gray-400 flex-shrink-0" />{prospect.contactNom}</p>}
              {prospect.contactEmail ? (
                <a href={`mailto:${prospect.contactEmail}`} className="text-sm text-emerald-600 hover:underline flex items-center gap-2">
                  <Mail size={14} className="text-gray-400 flex-shrink-0" />{prospect.contactEmail}
                </a>
              ) : (
                <p className="text-sm text-gray-400 italic flex items-center gap-2"><Mail size={14} className="text-gray-300 flex-shrink-0" />Email non renseigné</p>
              )}
              {prospect.contactTelephone && <a href={`tel:${prospect.contactTelephone}`} className="text-sm text-emerald-600 hover:underline flex items-center gap-2"><Phone size={14} className="text-gray-400 flex-shrink-0" />{prospect.contactTelephone}</a>}
              {prospect.adresse && <p className="text-sm text-gray-700 flex items-center gap-2"><MapPin size={14} className="text-gray-400 flex-shrink-0" />{prospect.adresse}</p>}
              {prospect.siteWeb && <a href={prospect.siteWeb} target="_blank" rel="noopener noreferrer" className="text-sm text-emerald-600 hover:underline flex items-center gap-2"><Globe size={14} className="text-gray-400 flex-shrink-0" />{prospect.siteWeb}<ExternalLink size={10} /></a>}
              {!prospect.contactNom && !prospect.contactEmail && !prospect.contactTelephone && (
                <p className="text-xs text-gray-400 italic">Aucun contact renseigné</p>
              )}
            </div>
          </div>

          {/* Données SENTINELLE */}
          <div className="bg-amber-50 rounded-xl shadow-sm p-4 border border-amber-100">
            <p className="text-xs font-semibold text-amber-600 uppercase mb-3">Données SENTINELLE</p>
            <div className="space-y-2">
              {prospect.tailleStructure && (
                <div className="flex items-start gap-2 text-sm">
                  <Ruler size={14} className="text-amber-400 mt-0.5 flex-shrink-0" />
                  <div><p className="text-xs text-gray-400">Taille / Adhérents</p><p className="text-gray-700">{prospect.tailleStructure}</p></div>
                </div>
              )}
              {prospect.objectifContact && (
                <div className="flex items-start gap-2 text-sm">
                  <Crosshair size={14} className="text-amber-400 mt-0.5 flex-shrink-0" />
                  <div><p className="text-xs text-gray-400">Objectif</p><p className="text-gray-700">{prospect.objectifContact}</p></div>
                </div>
              )}
              {prospect.problematiques?.length > 0 && (
                <div>
                  <p className="text-xs text-gray-400 flex items-center gap-1 mb-1"><AlertTriangle size={12} /> Problématiques</p>
                  <div className="flex flex-wrap gap-1">
                    {prospect.problematiques.map((p, i) => (
                      <span key={i} className="text-xs px-2 py-0.5 bg-red-50 text-red-700 rounded border border-red-200">{p}</span>
                    ))}
                  </div>
                </div>
              )}
              {prospect.prochaineAction && (
                <div className="flex items-start gap-2 text-sm">
                  <CalendarClock size={14} className="text-amber-500 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="text-xs text-gray-400">Prochaine action</p>
                    <p className="text-gray-700">{prospect.prochaineAction}
                      {prospect.dateProchaineAction && <span className="text-amber-600 font-semibold ml-2">— {formatDate(prospect.dateProchaineAction)}</span>}
                    </p>
                  </div>
                </div>
              )}
              {!prospect.tailleStructure && !prospect.objectifContact && !prospect.prochaineAction && !(prospect.problematiques?.length > 0) && (
                <p className="text-xs text-amber-600 italic">Aucune donnée — modifier la fiche pour enrichir.</p>
              )}
            </div>
          </div>

          {/* Dates clés */}
          <div className="bg-white rounded-xl shadow-sm p-4">
            <p className="text-xs font-semibold text-gray-400 uppercase mb-3">Dates clés</p>
            <div className="space-y-1.5 text-sm">
              <div className="flex justify-between"><span className="text-gray-400 text-xs">Créé le</span><span className="text-gray-700 text-xs">{formatDate(prospect.createdAt)}</span></div>
              {prospect.datePremierContact && <div className="flex justify-between"><span className="text-gray-400 text-xs">1er contact</span><span className="text-gray-700 text-xs">{formatDate(prospect.datePremierContact)}</span></div>}
              {prospect.dateConversion && <div className="flex justify-between"><span className="text-gray-400 text-xs">Converti le</span><span className="text-emerald-600 font-semibold text-xs">{formatDate(prospect.dateConversion)}</span></div>}
              {prospect.source && <div className="flex justify-between"><span className="text-gray-400 text-xs">Source</span><span className="text-gray-700 text-xs">{prospect.source}</span></div>}
            </div>
          </div>

          {/* Client converti */}
          {prospect.clientUserId && (
            <div className="bg-emerald-50 rounded-xl p-4 border border-emerald-200">
              <p className="text-xs font-semibold text-emerald-600 uppercase mb-2">Client Copro Protect</p>
              <p className="text-sm text-emerald-800"><span className="font-semibold">Email :</span> {prospect.clientEmail}</p>
              <p className="text-sm text-emerald-800"><span className="font-semibold">Formule :</span> {prospect.formuleClient}</p>
            </div>
          )}

          {/* Rapprochement */}
          {prospect.statut === 'converti' && !prospect.clientUserId && prospect.contactEmail && (
            <button onClick={handleRapprocher}
              className="w-full flex items-center justify-center gap-2 py-2.5 bg-emerald-50 text-emerald-700 rounded-lg hover:bg-emerald-100 border border-emerald-200 text-sm font-semibold transition-colors">
              <ArrowRightLeft size={16} /> Rapprocher avec un compte Copro Protect
            </button>
          )}
        </div>

        {/* ===== COLONNE CENTRALE — Timeline + Documents ===== */}
        <div className="overflow-y-auto p-4 space-y-4 border-r border-gray-100">

          {/* Ajouter note */}
          <div className="bg-white rounded-xl shadow-sm p-4">
            <p className="text-xs font-semibold text-gray-400 uppercase mb-3">Ajouter une note</p>
            <div className="flex gap-2">
              <input type="text" value={nouvelleNote} onChange={(e) => setNouvelleNote(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleAjouterNote()}
                className="flex-1 px-3 py-2 border rounded-lg text-sm focus:ring-2 focus:ring-emerald-500"
                placeholder="Compte-rendu d'appel, observation, point d'attention..." />
              <button onClick={handleAjouterNote} disabled={!nouvelleNote.trim() || ajoutEnCours}
                className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 disabled:opacity-50 transition-colors">
                <MessageSquarePlus size={18} />
              </button>
            </div>
          </div>

          {/* Documents déposés */}
          <div className="bg-white rounded-xl shadow-sm p-4">
            <div className="flex items-center justify-between mb-3">
              <p className="text-xs font-semibold text-gray-400 uppercase">
                Documents ({documents.length})
              </p>
            </div>
            {documents.length === 0 ? (
              <div className="text-center py-6">
                <FileText size={28} className="text-gray-200 mx-auto mb-2" />
                <p className="text-xs text-gray-400">Aucun document déposé</p>
                <p className="text-xs text-gray-300 mt-0.5">Utilisez SENTINELLE pour déposer une réponse PDF</p>
              </div>
            ) : (
              <div className="space-y-2">
                {documents.map((doc) => (
                  <div key={doc.id} className="flex items-center justify-between p-2.5 bg-gray-50 rounded-lg border border-gray-100 group">
                    <div className="flex items-center gap-2.5 min-w-0">
                      <FileText size={16} className="text-blue-500 flex-shrink-0" />
                      <div className="min-w-0">
                        <p className="text-sm font-semibold text-gray-700 truncate">{doc.nom}</p>
                        <div className="flex items-center gap-2 mt-0.5">
                          <span className={`text-xs px-1.5 py-0.5 rounded font-semibold ${COULEURS_TYPE_DOCUMENT_PROSPECT[doc.type]}`}>
                            {LABELS_TYPE_DOCUMENT_PROSPECT[doc.type]}
                          </span>
                          {doc.taille && <span className="text-xs text-gray-400">{formatTaille(doc.taille)}</span>}
                          <span className="text-xs text-gray-400">
                            {doc.createdAt?.toDate?.()?.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' }) || ''}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      <a href={doc.storageUrl} target="_blank" rel="noopener noreferrer"
                        className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                        <Download size={14} />
                      </a>
                      {confirmSuppDoc === doc.id ? (
                        <div className="flex items-center gap-1">
                          <button onClick={() => handleSupprimerDocument(doc)}
                            className="text-xs px-2 py-0.5 bg-red-500 text-white rounded hover:bg-red-600">Oui</button>
                          <button onClick={() => setConfirmSuppDoc(null)}
                            className="text-xs px-2 py-0.5 bg-gray-200 rounded hover:bg-gray-300">Non</button>
                        </div>
                      ) : (
                        <button onClick={() => setConfirmSuppDoc(doc.id)}
                          className="p-1.5 text-gray-300 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors">
                          <Trash size={14} />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Timeline */}
          <div className="bg-white rounded-xl shadow-sm p-4">
            <div className="flex items-center justify-between mb-4">
              <p className="text-xs font-semibold text-gray-400 uppercase">
                Timeline ({evenements.length} événement{evenements.length > 1 ? 's' : ''})
              </p>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setShowModaleMail(true)}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 text-white text-xs font-semibold rounded-lg hover:bg-blue-700 transition-colors">
                  <Sparkles size={12} /> Générer un mail
                </button>
                <button
                  onClick={() => setShowImportReponse(true)}
                  disabled={importEnCours}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-emerald-600 text-white text-xs font-semibold rounded-lg hover:bg-emerald-700 disabled:opacity-60 transition-colors">
                  {importEnCours
                    ? <><RefreshCw size={12} className="animate-spin" /> Analyse...</>
                    : <><ArrowDownLeft size={12} /> Importer une réponse</>
                  }
                </button>
              </div>
            </div>
            {evenements.length === 0 ? (
              <div className="text-center py-12">
                <Clock size={36} className="text-gray-200 mx-auto mb-3" />
                <p className="text-sm text-gray-400">Aucun événement pour l'instant.</p>
                <p className="text-xs text-gray-300 mt-1">Les notes et les mails apparaîtront ici.</p>
              </div>
            ) : (
              <div className="relative">
                <div className="absolute left-4 top-0 bottom-0 w-px bg-gray-200" />
                <div className="space-y-4">
                  {evenements.map((evt, index) => (
                    <div key={index} className="flex gap-4 relative">
                      <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center z-10 ${
                        evt.type === 'mail'
                          ? (evt.data.type === 'recu' ? 'bg-emerald-100' : evt.data.envoye ? 'bg-blue-100' : 'bg-amber-100')
                          : 'bg-gray-100'
                      }`}>
                        {evt.type === 'mail' ? (
                          evt.data.type === 'recu'
                            ? <ArrowDownLeft size={14} className="text-emerald-600" />
                            : evt.data.envoye ? <Send size={14} className="text-blue-600" /> : <Clock size={14} className="text-amber-600" />
                        ) : (
                          <StickyNote size={14} className="text-gray-500" />
                        )}
                      </div>
                      <div className="flex-1 pb-4">
                        {evt.type === 'mail' ? (
                          evt.data.type === 'recu' ? (
                            // ---- RÉPONSE REÇUE ----
                            <div className="rounded-xl p-3 border bg-emerald-50 border-emerald-100">
                              <div className="flex items-center justify-between mb-1">
                                <div className="flex items-center gap-2">
                                  <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-emerald-200 text-emerald-800">
                                    Réponse reçue
                                  </span>
                                  {evt.data.analyseReponse && (
                                    <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${COULEURS_QUALIFICATION_REPONSE[evt.data.analyseReponse.qualification]}`}>
                                      {LABELS_QUALIFICATION_REPONSE[evt.data.analyseReponse.qualification]}
                                    </span>
                                  )}
                                </div>
                                <span className="text-[10px] text-gray-400">{formatDateRelative(evt.date)}</span>
                              </div>
                              <p className="font-semibold text-gray-800 text-sm">{evt.data.objet || 'Réponse importée'}</p>
                              {evt.data.fichierPdfUrl && (
                                <a href={evt.data.fichierPdfUrl} target="_blank" rel="noopener noreferrer"
                                  className="inline-flex items-center gap-1 text-xs text-emerald-700 hover:underline mt-1">
                                  <FileText size={11} /> Ouvrir le PDF
                                </a>
                              )}
                              {evt.data.analyseReponse ? (
                                <div className="mt-2 space-y-2">
                                  <p className="text-xs text-gray-700">{evt.data.analyseReponse.resume}</p>
                                  {evt.data.analyseReponse.pointsTraites.length > 0 && (
                                    <div>
                                      <p className="text-[10px] font-semibold text-emerald-700 uppercase mb-0.5">Points traités</p>
                                      <ul className="space-y-0.5">
                                        {evt.data.analyseReponse.pointsTraites.map((p, i) => (
                                          <li key={i} className="flex items-start gap-1.5 text-xs text-gray-600">
                                            <span className="text-emerald-500 mt-0.5 flex-shrink-0">✓</span>{p}
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  )}
                                  {evt.data.analyseReponse.pointsIgnores.length > 0 && (
                                    <div>
                                      <p className="text-[10px] font-semibold text-amber-700 uppercase mb-0.5">Points ignorés</p>
                                      <ul className="space-y-0.5">
                                        {evt.data.analyseReponse.pointsIgnores.map((p, i) => (
                                          <li key={i} className="flex items-start gap-1.5 text-xs text-gray-600">
                                            <span className="text-amber-500 mt-0.5 flex-shrink-0">—</span>{p}
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  )}
                                  <div className="bg-white rounded-lg p-2 border border-emerald-200">
                                    <p className="text-[10px] font-semibold text-gray-500 uppercase mb-0.5">Recommandation</p>
                                    <p className="text-xs text-gray-700">{evt.data.analyseReponse.recommandation}</p>
                                  </div>
                                  {evt.data.analyseReponse.brouillonRelance && (
                                    <button
                                      onClick={() => setBrouillonRelanceMailId(evt.data.id)}
                                      className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-emerald-600 text-white text-xs font-semibold rounded-lg hover:bg-emerald-700 transition-colors">
                                      <RefreshCw size={13} /> Générer la relance SCUD
                                    </button>
                                  )}
                                </div>
                              ) : (
                                <p className="text-xs text-gray-400 mt-1 italic">Analyse SENTINELLE en cours...</p>
                              )}
                            </div>
                          ) : (
                            // ---- MAIL ENVOYÉ / BROUILLON ----
                            <div
                              className={`rounded-xl p-3 border cursor-pointer transition-shadow hover:shadow-md ${evt.data.envoye ? 'bg-blue-50 border-blue-100' : 'bg-amber-50 border-amber-100'}`}
                              onClick={() => { setMailDetail(evt.data); setMailDetailTexte(evt.data.apercu || ''); setMailDetailEnvoiOk(false); }}
                            >
                              <div className="flex items-center justify-between mb-1">
                                <div className="flex items-center gap-2">
                                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${evt.data.envoye ? 'bg-blue-200 text-blue-800' : 'bg-amber-200 text-amber-800'}`}>
                                    {evt.data.envoye ? 'Mail envoyé' : 'Brouillon'}
                                  </span>
                                  <span className="text-xs text-gray-500">{LABELS_TYPE_TEMPLATE[evt.data.template] || evt.data.template}</span>
                                </div>
                                <span className="text-[10px] text-gray-400">{formatDateRelative(evt.date)}</span>
                              </div>
                              <p className="font-semibold text-gray-800 text-sm">{evt.data.objet}</p>
                              {evt.data.apercu && <p className="text-xs text-gray-500 mt-1 line-clamp-3">{evt.data.apercu}</p>}
                              {evt.data.destinataire && (
                                <p className="text-xs text-gray-400 mt-1.5 flex items-center gap-1">
                                  <Mail size={10} /> {evt.data.destinataire}
                                </p>
                              )}
                              {/* Actions mail */}
                              <div
                                className="mt-2 pt-2 border-t border-gray-200/60 flex items-center justify-between"
                                onClick={(e) => e.stopPropagation()}
                              >
                                {/* Marquer comme envoyé — seulement si brouillon ou non encore envoyé */}
                                {(evt.data.type === 'brouillon' || (!evt.data.type && !evt.data.envoye)) && (
                                  <button
                                    onClick={() => handleMarquerEnvoye(evt.data.id)}
                                    disabled={marquerEnvoyeEnCours}
                                    className="flex items-center gap-1 text-[10px] text-blue-500 hover:text-blue-700 transition-colors disabled:opacity-50"
                                  >
                                    <CheckCircle size={11} /> Marquer comme envoyé
                                  </button>
                                )}
                                {!(evt.data.type === 'brouillon' || (!evt.data.type && !evt.data.envoye)) && <span />}
                                {/* Suppression */}
                                {confirmSuppMail === evt.data.id ? (
                                  <div className="flex items-center gap-2">
                                    <span className="text-[10px] text-red-600 font-semibold">Supprimer ?</span>
                                    <button onClick={() => handleSupprimerMail(evt.data.id)} disabled={suppressionMailEnCours}
                                      className="px-2 py-1 bg-red-600 text-white text-[10px] rounded hover:bg-red-700 disabled:opacity-50 transition-colors">
                                      {suppressionMailEnCours ? '...' : 'Confirmer'}
                                    </button>
                                    <button onClick={() => setConfirmSuppMail(null)}
                                      className="px-2 py-1 bg-gray-200 text-gray-600 text-[10px] rounded hover:bg-gray-300 transition-colors">
                                      Annuler
                                    </button>
                                  </div>
                                ) : (
                                  <button onClick={() => setConfirmSuppMail(evt.data.id)}
                                    className="flex items-center gap-1 text-[10px] text-red-300 hover:text-red-500 transition-colors">
                                    <Trash2 size={11} /> Supprimer
                                  </button>
                                )}
                              </div>
                            </div>
                          )
                        ) : (
                          <div className="bg-gray-50 rounded-xl p-3 border border-gray-100">
                            <div className="flex items-center justify-between mb-1">
                              <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${getCouleurResponsable(evt.data.auteur, responsables)}`}>
                                {getLabelResponsable(evt.data.auteur, responsables).split(' ')[0]}
                              </span>
                              <span className="text-[10px] text-gray-400">{formatDateRelative(evt.date)}</span>
                            </div>
                            {noteEnEdition === evt.data.id ? (
                              <div className="space-y-2 mt-1">
                                <textarea
                                  value={texteEditionNote}
                                  onChange={(e) => setTexteEditionNote(e.target.value)}
                                  rows={3}
                                  className="w-full text-sm text-gray-700 border border-gray-300 rounded-lg p-2 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-400"
                                />
                                <div className="flex gap-2">
                                  <button onClick={handleValiderEditionNote}
                                    className="px-3 py-1 bg-emerald-600 text-white text-xs font-semibold rounded-lg hover:bg-emerald-700">
                                    Enregistrer
                                  </button>
                                  <button onClick={() => { setNoteEnEdition(null); setTexteEditionNote(''); }}
                                    className="px-3 py-1 bg-gray-100 text-gray-600 text-xs rounded-lg hover:bg-gray-200">
                                    Annuler
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <>
                                <p className="text-sm text-gray-700">{evt.data.texte}</p>
                                <div className="flex gap-3 mt-2">
                                  <button
                                    onClick={() => { setNoteEnEdition(evt.data.id); setTexteEditionNote(evt.data.texte); }}
                                    className="text-[10px] text-blue-500 hover:text-blue-700 font-medium flex items-center gap-1">
                                    ✏ Modifier
                                  </button>
                                  <button
                                    onClick={() => handleSupprimerNote(evt.data.id)}
                                    className="text-[10px] text-red-400 hover:text-red-600 font-medium flex items-center gap-1">
                                    ✕ Supprimer
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ===== COLONNE DROITE — SENTINELLE CRM ===== */}
        <div className="flex flex-col p-4">
          {prospect ? (
            <SentinelleCrmPanel
              prospect={prospect}
              onDocumentDepose={() => { chargerDocumentsProspect(prospect.id).then(setDocuments); }}
              onMailGenere={() => charger()}
            />
          ) : null}
        </div>
      </div>

      {/* Modales */}
      {showEdition && (
        <ModalEdition prospect={prospect} responsables={responsables}
          onFermer={() => setShowEdition(false)} onSauvegarder={handleSauvegarder} />
      )}

      {/* Modal génération mail SENTINELLE */}
      {showModaleMail && (
        <ModalMailSentinelle
          prospect={prospect}
          onFermer={() => setShowModaleMail(false)}
          onMailGenere={() => { setShowModaleMail(false); charger(); }}
          onMarquerEnvoye={async (mailId, contenuFinal) => {
            await marquerMailEnvoye(prospect.id, mailId, contenuFinal);
            // Glissement automatique Kanban : identifié → contacté dès qu'un mail est archivé comme envoyé
            if (prospect.statut === 'identifie') {
              await changerStatutProspect(prospect.id, 'contacte');
            }
            await charger();
          }}
        />
      )}

      {/* Modal import réponse */}
      {showImportReponse && (
        <ModalImportReponse
          onFermer={() => setShowImportReponse(false)}
          onImporter={handleImporterReponse}
        />
      )}

      {/* Modale — Marquer comme envoyé avec contenu réel éditable */}
      {modaleMarquerEnvoye && (
        <div className="fixed inset-0 bg-black/50 z-[70] flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg flex flex-col max-h-[80vh]">
            <div className="flex items-center justify-between p-4 border-b border-gray-100">
              <div>
                <h3 className="font-semibold text-gray-800">Confirmer l'envoi</h3>
                <p className="text-xs text-gray-500 mt-0.5">Corrigez si nécessaire le contenu réellement envoyé — c'est cette version qui sera archivée.</p>
              </div>
              <button onClick={() => setModaleMarquerEnvoye(null)} className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors">
                <X size={16} className="text-gray-400" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-4">
              <textarea
                value={modaleMarquerEnvoye.contenu}
                onChange={(e) => setModaleMarquerEnvoye(prev => prev ? { ...prev, contenu: e.target.value } : null)}
                rows={12}
                placeholder="Collez ici le contenu exact du mail envoyé depuis Gmail…"
                className="w-full text-sm text-gray-700 border border-gray-200 rounded-lg p-3 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-400"
              />
            </div>
            <div className="p-4 border-t border-gray-100 flex items-center justify-end gap-3">
              <button onClick={() => setModaleMarquerEnvoye(null)} className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 transition-colors">
                Annuler
              </button>
              <button
                onClick={handleConfirmerEnvoye}
                disabled={marquerEnvoyeEnCours}
                className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors"
              >
                <CheckCircle size={14} />
                {marquerEnvoyeEnCours ? 'Archivage…' : 'Archiver comme envoyé'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modale — Consultation mail complet */}
      {mailDetail && (
        <div className="fixed inset-0 bg-black/50 z-[70] flex items-center justify-center p-4" onClick={() => setMailDetail(null)}>
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl flex flex-col max-h-[85vh]" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className={`flex items-center justify-between p-4 rounded-t-xl ${mailDetail.envoye ? 'bg-blue-600' : 'bg-amber-500'}`}>
              <div className="flex items-center gap-3 text-white min-w-0">
                <Send size={18} className="shrink-0" />
                <div className="min-w-0">
                  <p className="font-bold text-sm truncate">{mailDetail.objet}</p>
                  <p className="text-xs text-white/70 mt-0.5">
                    {mailDetail.envoye ? 'Mail envoyé' : 'Brouillon'} · {LABELS_TYPE_TEMPLATE[mailDetail.template] || mailDetail.template}
                    {mailDetail.destinataire && ` · ${mailDetail.destinataire}`}
                  </p>
                </div>
              </div>
              <button onClick={() => setMailDetail(null)} className="p-1.5 text-white/80 hover:text-white shrink-0">
                <X size={18} />
              </button>
            </div>
            {/* Corps */}
            <div className="flex-1 overflow-y-auto p-5">
              {!mailDetail.envoye ? (
                <textarea
                  value={mailDetailTexte}
                  onChange={(e) => setMailDetailTexte(e.target.value)}
                  className="w-full h-64 px-3 py-2 border rounded-lg text-sm text-gray-800 focus:ring-2 focus:ring-amber-400 resize-none leading-relaxed"
                />
              ) : mailDetail.apercu ? (
                <p className="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">{mailDetail.apercu}</p>
              ) : (
                <p className="text-sm text-gray-400 italic">Aucun contenu archivé.</p>
              )}
            </div>
            {/* Footer */}
            <div className="p-4 border-t border-gray-100 space-y-3">
              {/* Rappel PDF — brouillon uniquement */}
              {!mailDetail.envoye && (
                <div className="flex items-center gap-3 bg-amber-50 border border-amber-200 rounded-lg px-4 py-2.5">
                  <AlertTriangle size={16} className="text-amber-600 shrink-0" />
                  <p className="text-sm text-amber-800 font-semibold">N'oubliez pas de joindre le PDF de présentation manuellement dans Gmail.</p>
                </div>
              )}
              <div className="flex items-center justify-between">
                <p className="text-xs text-gray-400">
                  {mailDetail.date ? formatDate(mailDetail.date) : ''}
                </p>
                <div className="flex items-center gap-2">
                  {!mailDetail.envoye && !mailDetailEnvoiOk && (
                    <button
                      onClick={() => {
                        const to = encodeURIComponent(mailDetail.destinataire || '');
                        const subject = encodeURIComponent(mailDetail.objet);
                        const body = encodeURIComponent(mailDetailTexte);
                        window.open(`https://mail.google.com/mail/?view=cm&to=${to}&su=${subject}&body=${body}`, '_blank');
                        setMailDetailEnvoiOk(true);
                      }}
                      className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 font-semibold transition-colors"
                    >
                      <ExternalLink size={14} /> Ouvrir dans Gmail
                    </button>
                  )}
                  {mailDetailEnvoiOk && !mailDetail.envoye && (
                    <button
                      onClick={() => {
                        if (mailDetail.id) {
                          handleMarquerEnvoye(mailDetail.id);
                        }
                        setMailDetail(null);
                      }}
                      className="flex items-center gap-1.5 px-3 py-1.5 bg-emerald-600 text-white text-sm rounded-lg hover:bg-emerald-700 font-semibold transition-colors"
                    >
                      <Check size={14} /> Confirmer l'envoi
                    </button>
                  )}
                  <button
                    onClick={() => {
                      const texte = mailDetail.envoye ? mailDetail.apercu : mailDetailTexte;
                      if (texte) navigator.clipboard.writeText(`Objet : ${mailDetail.objet}\n\n${texte}`);
                    }}
                    className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
                  >
                    <Copy size={14} /> Copier
                  </button>
                  <button onClick={() => setMailDetail(null)} className="px-4 py-1.5 bg-gray-100 text-gray-600 text-sm rounded-lg hover:bg-gray-200 transition-colors">
                    Fermer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal brouillon relance SCUD */}
      {brouillonRelanceMailId && (() => {
        const mail = prospect.historiqueMails?.find((m) => m.id === brouillonRelanceMailId);
        if (!mail?.analyseReponse?.brouillonRelance) return null;
        return (
          <div className="fixed inset-0 bg-black/50 z-[70] flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[80vh] flex flex-col">
              <div className="flex items-center justify-between p-4 border-b">
                <div>
                  <h2 className="text-lg font-bold text-gray-800">Brouillon de relance SCUD</h2>
                  <p className="text-xs text-gray-500 mt-0.5">Généré par SENTINELLE — à personnaliser avant envoi</p>
                </div>
                <button onClick={() => setBrouillonRelanceMailId(null)} className="p-1 hover:bg-gray-100 rounded"><X size={20} /></button>
              </div>
              <div className="flex-1 overflow-y-auto p-4">
                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <p className="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">{mail.analyseReponse.brouillonRelance}</p>
                </div>
                <div className="mt-3 bg-amber-50 border border-amber-200 rounded-lg p-3">
                  <p className="text-xs text-amber-700">
                    <strong>Rappel SCUD</strong> — Ce brouillon suit la méthode béotien naïf : il demande de l'aide, ne réclame pas. Copiez le contenu, ouvrez Gmail, personnalisez si besoin, envoyez.
                  </p>
                </div>
              </div>
              <div className="flex justify-end gap-3 p-4 border-t bg-gray-50 rounded-b-xl">
                <button onClick={() => setBrouillonRelanceMailId(null)}
                  className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-200 rounded-lg">
                  Fermer
                </button>
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(mail.analyseReponse!.brouillonRelance!);
                    setBrouillonRelanceMailId(null);
                  }}
                  className="flex items-center gap-2 px-6 py-2 bg-emerald-600 text-white text-sm font-semibold rounded-lg hover:bg-emerald-700">
                  <Copy size={15} /> Copier le brouillon
                </button>
              </div>
            </div>
          </div>
        );
      })()}

    </div>
  );
};

export default CrmProspectDetailPage;
